import { motion } from "framer-motion";

const FOUNDER = "/founder-kenneth.jpg";
const BRANCHES = ["Army", "Navy", "Marine Corps", "Air Force", "Coast Guard"];

export default function FounderCredibility() {
  return (
    <section id="mission" className="section">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.7 }} className="md:col-span-5"
        >
          <div className="relative rounded-3xl overflow-hidden border border-slate-200">
            <img src={FOUNDER} alt="Kenneth E. Kight, co-founder" className="w-full h-[420px] md:h-[520px] object-cover object-top" />
            <div className="absolute bottom-4 left-4 right-4 glass rounded-2xl px-4 py-3 flex items-center justify-between">
              <div className="flex flex-col">
                <span className="text-[11px] tracking-[0.18em] uppercase text-slate-500">Co-Founder</span>
                <span className="text-sm text-[#0A1930] font-medium">Kenneth E. Kight</span>
              </div>
              <span className="text-[11px] text-[#0A1930] font-medium">5 Branches</span>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }} className="md:col-span-7"
        >
          <p className="text-[11px] tracking-[0.22em] uppercase text-slate-500">Our Mission</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0A1930] mt-3 leading-[1.05]">
            Founded by Veterans. Built for Veterans.
          </h2>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-xl">
            Our founders served across <span className="text-[#0A1930] font-medium">five branches of the U.S. military</span>.
            We understand military culture, the language, and the VA system from the inside.
            We're mission-driven — because we've lived this.
          </p>
          <p className="mt-4 text-base text-slate-500 leading-relaxed max-w-xl">
            Too many Veterans leave benefits on the table simply because the process is confusing.
            We exist to change that — with respect, clarity, and zero upfront cost.
          </p>
          <div className="mt-8 flex flex-wrap gap-2" data-testid="branches-row">
            {BRANCHES.map((b) => (
              <span key={b} className="text-[12px] tracking-wide rounded-full border border-slate-200 px-3 py-1.5 text-slate-700">
                U.S. {b}
              </span>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
